/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { AiFillHeart } from 'react-icons/ai';
import LazyImage from '../../../Utils/Components/lazyImageComponent';
import placeholder from '../../../../assets/images/placeholder.png';
import meavanaLogo from '../../../../assets/images/MeaVanaLogo.png';
import { FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import moreTags from '../../../../assets/images/more.png';

type discoverTopicCardProps = {
	id: string;
	name: string;
	imagesCount: number;
	usersCount: number;
	image: any;
	creator: any[];
	tags: string[];
	createdAt: string;
};

function DiscoverTopicCard({
	id,
	name,
	usersCount,
	image,
	creator,
	tags
}: discoverTopicCardProps) {
	const TagComponent = ({ name }: { name: string }) => {
		return (
			<div
				className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 h-8
													bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
													dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
													dark:text-gray-300 text-gray-600 hover:text-gray-200"
			>
				<span className="text-xs font-bold mx-1">{name.toUpperCase()}</span>
			</div>
		);
	};

	const MoreTagComponent = () => {
		return (
			<div
				className="flex justify-center items-center py-1.5 px-0.5 rounded-full w-fit transition-all duration-500 h-8
													bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
													dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
													dark:text-gray-300 text-gray-600 hover:text-gray-200"
			>
				<img src={moreTags} className="rounded-box object-cover h-8 w-8" />
			</div>
		);
	};

	const navigate = useNavigate();
	return (
		<div
			className="bg-gray-200 dark:bg-gray-700 hover:bg-gray-800 dark:hover:bg-gray-200 shadow-xl hover:shadow-none cursor-pointer
            w-80 rounded-3xl flex flex-col items-center justify-center 
            transition-all duration-500 ease-in-out group"
			onClick={() => {
				navigate(`../topic/${id}`);
			}}
		>
			<div className="relative flex flex-col mt-2 mx-2">
				<div className="w-full min-h-[200px] min-w-[300px] rounded-2xl overflow-hidden">
					<LazyImage
						photo={
							image != null
								? image.url_low_res != null
									? image.url_low_res
									: placeholder
								: placeholder
						}
						style={
							'block object-cover object-center w-full aspect-[16/10] rounded-lg max-h-[240px]'
						}
						placeholderStyle={
							'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
						}
						loaderDimesnions={120}
					/>
				</div>
				<div className=" flex flex-row w-full h-10">
					<div
						className="h-8 w-8 flex items-center justify-center bg-white dark:bg-gray-800 hover:bg-red-500 dark:hover:bg-red-500
                     text-red-500 hover:text-white rounded-2xl shadow-xl transform-gpu translate-y-0 hover:-translate-y-1 
                     transition-all duration-300 ease-in-out"
					>
						<AiFillHeart size={16} />
					</div>
					<div
						className="h-8 w-fit ml-2 bg-white dark:bg-gray-800 hover:bg-blue-600 dark:hover:bg-blue-600 flex items-center align-middle
                        justify-center font-medium text-blue-600 hover:text-white rounded-2xl shadow-xl
                        transform-gpu translate-y-0 hover:-translate-y-1 transition-all duration-300 ease-in-out group-1"
					>
						<FaUser size={14} className="ml-2" />
						<span className="text-sm text-gray-800 dark:text-white ml-1 mr-2 -mt-0.5 group-1-hover:text-white dark:group-1-hover:text-white mx-2">
							{usersCount}
						</span>
					</div>

					<div className="flex flex-row space-x-2 ml-auto">
						{tags != null &&
							(tags.length < 3 ? (
								tags.map((tag) => <TagComponent name={tag} />)
							) : (
								<>
									{tags.slice(0, 2).map((tag) => (
										<TagComponent name={tag} />
									))}
									<MoreTagComponent />
								</>
							))}
					</div>
				</div>
			</div>
			<div className="pt-1 w-full px-4">
				<h1 className="font-medium leading-none text-base tracking-wider text-gray-800 dark:text-white group-hover:text-white dark:group-hover:text-gray-800">
					{name}
				</h1>
			</div>
			<div
				className="flex justify-start w-full pt-3 px-4 mb-1"
				onClick={(e) => {
					if (creator.length > 0) {
						e.stopPropagation();
						navigate(`../user/${creator[0]._id}`);
					}
				}}
			>
				<div className="mr-1">
					<LazyImage
						photo={
							creator.length > 0
								? creator[0].photo != null
									? creator[0].photo
									: `https://api.dicebear.com/7.x/bottts/svg?seed=${creator[0].username}`
								: meavanaLogo
						}
						dimesnions={{ width: '23', height: '23' }}
						loaderDimesnions={23}
					/>
				</div>
				<div className="font-medium text-sm text-gray-800 dark:text-white group-hover:text-white dark:group-hover:text-gray-800">
					{creator.length > 0 ? creator[0].username : 'Meavana'}
				</div>
			</div>
		</div>
	);
}

export default DiscoverTopicCard;
